import Button from "../../../shared/components/Button";
import { useTimeLoggerContext } from "./TimeLoggerContext";

export default function TimeLogger() {
  const { seconds, stopTimer, startTimer, pauseTimer } = useTimeLoggerContext();

  return (
    <>
      <span
        style={{ fontSize: "1.1rem", fontWeight: "bold" }}
        className="ml-auto mr-3 "
      >
        {formatSeconds(seconds)}
      </span>
      <div style={{ display: "flex", gap: 5 }}>
        <Button
          onClick={() => startTimer()}
          style={{
            display: "flex",
            alignItems: "center",
            height: 10,
            minWidth: "fit-content",
          }}
          variant="app"
        >
          <i className="fas fa-play-circle"></i>
        </Button>
        <Button
          onClick={() => pauseTimer()}
          style={{
            display: "flex",
            alignItems: "center",
            height: 10,
            minWidth: "fit-content",
          }}
          variant="app"
        >
          <i className="fas fa-pause-circle"></i>
        </Button>
        <Button
          onClick={() => stopTimer()}
          style={{
            display: "flex",
            alignItems: "center",
            height: 10,
            minWidth: "fit-content",
          }}
          variant="app"
        >
          <i className="fas fa-stop"></i>
        </Button>
      </div>
    </>
  );
}

function formatSeconds(seconds) {
  return new Date(seconds * 1000).toISOString().slice(11, 19);
}
